<template>
  <div>
    <BreadCrumb class="bread" :breads="['分级管理','分级审核','审核']"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">审核</span>
        <router-link :to="{path:'/index/gradeAudit',query:$route.query}">
          <el-button class="backList" size="small">返回列表</el-button>
        </router-link>
      </div>
      <div class="form">
        <el-form
          label-position="right"
          label-width="180px"
          :model="ruleForm"
          ref="ruleForm"
          :rules="rules"
        >
          <el-row>
            <el-form-item label="登陆账号" prop="username">
              <span>
                <el-input
                  maxlength="20"
                  placeholder="登陆账号"
                  :disabled="true"
                  v-model="ruleForm.username"
                ></el-input>
              </span>
            </el-form-item>
            <el-form-item label="真实姓名" prop="rel_name">
              <span>
                <el-input
                  maxlength="10"
                  placeholder="姓名"
                  disabled
                  v-model="ruleForm.rel_name"
                ></el-input>
              </span>
            </el-form-item>
            <!-- <el-form-item label="密码" prop="password">
              <span>
                <el-input
                  placeholder="密码"
                  minlength="6"
                  maxlength="20"
                  type="password"
                  v-model="ruleForm.password"
                  disabled
                ></el-input>
              </span>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
              <span>
                <el-input
                  placeholder="确认密码"
                  type="password"
                  v-model="ruleForm.checkPass"
                  disabled
                ></el-input>
              </span>
            </el-form-item> -->
            <el-form-item label="是否禁用" prop="status">
              <el-radio-group v-model="ruleForm.status">
                <el-radio
                  v-for="item in status"
                  :label="item.value"
                  disabled
                  :key="item.value"
                >{{item.label}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <p class="moreInfo">更多信息</p>
          <el-form-item label="手机" prop="phone">
            <span>
              <el-input
                maxlength="11"
                placeholder="手机"
                disabled
                v-model="ruleForm.phone"
              ></el-input>
            </span>
          </el-form-item>
          <el-form-item label="上级人员" prop="top_biz_user_id">
            <span>
              <el-input
                maxlength="11"
                disabled
                v-model="ruleForm.top_biz_user_id.rel_name"
              ></el-input>
            </span>
          </el-form-item>
          <el-form-item label="层级" prop="hierarchy_id">
            <span>
              <el-input
                maxlength="11"
                disabled
                v-model="ruleForm.hierarchy_id.name"
              ></el-input>
            </span>
          </el-form-item>
          <el-form-item label="头像" prop="imageUrl" :class="[ruleForm.role === '管理员' && this.$store.getters.authority({name: 'financeAudit',type: 'view'})?'':'uploadImage']">
            <upload
              v-model="ruleForm.imageUrl"
              :limit="1"
              maxSize="0.5"
              disabled
            ></upload>
          </el-form-item>
          <div style="text-align:center;margin-top:200px;">
            <el-button
              type="success"
              @click="submitForm('ruleForm',1)"
            >通过</el-button>
            <el-button
              type="success"
              @click="submitForm('ruleForm',0)"
            >不通过</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import apis from "@/config/apis";
import { OSSConfig, isEmail, isNumber } from "@/plugins/common";
import mouse from "@/assets/images/Image.jpg";
import upload from "@/components/SimpleUpload";
import { deepClone, getHost } from "@/plugins/util";
export default {
  data() {
    // var validatename = (rule, value, callback) => {
    //   let reg = /^[a-zA-Z\u4e00-\u9fa5]+$/;
    //   let regs = /^[0-9]*$/;
    //   if (!value) {
    //     callback(new Error("姓名不能为空"));
    //   } else {
    //     if (regs.test(value)) {
    //       callback(new Error("姓名不能为数字"));
    //     }
    //     if (!reg.test(value)) {
    //       callback(new Error("姓名为1-10个中文或英文,不包含特殊字符"));
    //     } else {
    //       callback();
    //     }
    //   }
    // };
    // var validateusername = (rule, value, callback) => {
    //   let reg = /^[A-z\d]{3,20}$/;
    //   if (!value) {
    //     callback(new Error("登陆账号不能为空"));
    //   } else {
    //     if (!reg.test(value)) {
    //       callback(new Error("登陆账号为3-20个英文或数字或下划线字符"));
    //     } else {
    //       callback();
    //     }
    //   }
    // };
    // var validatemobile = (rule, value, callback) => {
    //   let reg = /^((13[0-9])|(17[06-8])|(18[0-9])|(15[0-9]))\d{8}$/;
    //   if (!value) {
    //     callback(new Error("手机号不能为空"));
    //   } else {
    //     if (value.length < 11) {
    //       callback(new Error("请输入11位有效电话"));
    //     } else if (!reg.test(value)) {
    //       callback(new Error("请输入有效的手机号码"));
    //     } else {
    //       callback();
    //     }
    //   }
    // };
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        let regs = /^[0-9a-zA-Z_]*$/;
        if (!regs.test(value)) {
          callback(new Error("只允许数字、字母、下划线"));
        }
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        if (value.length < 6) {
          callback(new Error("密码长度不小于6位数"));
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (!value && !this.ruleForm.password) {
        callback();
      }
      if (this.ruleForm.checkPass !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      id: this.$route.query.id,
      imageUrl: "",
      radio: "1",
      status: [
        {
          value: "正常",
          label: "正常"
        },
        {
          value: "禁止",
          label: "禁用"
        }
      ],
      is_distribuistion: [
        {
          value: "是",
          label: "是"
        },
        {
          value: "否",
          label: "否"
        }
      ],
      ruleForm: {
        rel_name: "",
        username: "",
        status: "",
        password: "",
        checkPass: "",
        phone: "",
        imageUrl: mouse,
        // is_distribuistion: false,
      },
      imgURL: "",
      iS_noImg: "",
      old_imageUrl: "",
      rules: {
        status: [
          {
            required: true,
            message: "请选择是否禁用",
            trigger: "change"
          }
        ],
        // phone: [
        //   {
        //     required: true,
        //     validator: validatemobile,
        //     trigger: "blur"
        //   }
        // ],
        // rel_name: [
        //   {
        //     required: true,
        //     validator: validatename,
        //     trigger: "blur"
        //   }
        // ],
        // username: [
        //   {
        //     required: true,
        //     validator: validateusername,
        //     trigger: "blur"
        //   }
        // ],
        // mobile: [
        //   {
        //     required: true,
        //     validator: validatemobile,
        //     trigger: "blur"
        //   }
        // ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur"
          }
        ],
        checkPass: [
          {
            required: true,
            validator: validatePass2,
            trigger: "blur"
          }
        ],
        // imageUrl: [
        //   {
        //     required: true,
        //     message: "请上传头像",
        //     trigger: "change"
        //   }
        // ],
      }
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    getUser() {
      let url = `${apis.userList}/${this.id}`;
      this.$axios.get(url).then(data => {
        let datas = data.data;
        let {
          rel_name,
          username,
          phone,
          status,
          image_url,
          password,
          hierarchy_id,
          top_biz_user_id,
        } = datas.data.data;
        let thatStatus =
          status === "正常" ? "正常" : status === "禁止" ? "禁止" : "";
        this.ruleForm = {
          rel_name: rel_name,
          username: username,
          phone: phone,
          status: thatStatus,
          password: password,
          imageUrl: image_url,
          hierarchy_id,
          top_biz_user_id,
        };
        if (image_url) {
          this.ruleForm.imageUrl =
            "/" + this.ruleForm.imageUrl.replace(getHost(image_url), "");
        }
      });
    },
    submitForm(formName, type) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.sublimtUp(type);
        }
      });
    },
    /*提取上传逻辑*/
    sublimtUp(type) {
      // let {
        // password,
      // } = this.ruleForm;
      let jsonData = {
        biz_user_id: this.id,
        // password: Base64.encode(password),
        is_success: type,
      };
      let url = apis.verify_biz_user;
      this.$axios.post(url, jsonData).then(data => {
        let datas = data.data;
        if (datas.code == 200) {
          this.$message({
            type: "success",
            message: datas.msg
          });
          this.$router.push({
            path: "/index/gradeView",
            query: Object.assign({}, this.$route.query)
          });
        } else {
          this.$message({
            type: "error",
            message: datas.msg
          });
        }
      });
    },
  },
  components: {
    BreadCrumb,
    upload
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
<style lang="scss" scoped>
.wrap {
  height: 100%;
}

.bread {
  padding-bottom: 20px;
}

.nameFt {
  font-size: 14px;
  color: #333;
  padding-left: 17px;
}

.backList {
  width: 90px;
  margin-right: 20px;
}

.header {
  width: 100%;
  height: 46px;
  line-height: 46px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(236, 239, 241, 1);

  .addCustom {
    padding: 9px 10px;
    margin-right: 17px;
  }
}

.form {
  width: 90%;
  margin: 30px auto;
  clear: both;

  .el-form-item {
    width: 50%;
    float: left;

    .elInput {
      width: 100%;
    }
  }

  .line {
    width: 100%;
    height: 2px;
    border-bottom: 1px dotted #d8d8d8;
    padding-top: 200px;
    margin-top: 20px;
  }

  .moreInfo {
    margin-left: -5%;
    padding-top: 5px;
    color: #006633;
    font-weight: bolder;
  }

  .uploadImage {
    padding-top: -30px;
    width: 100%;
  }

  .el-autocomplete {
    width: 100%;
  }
}
</style>